module.exports = __webpack_public_path__ + "img/points_mod.21629154.svg";